export const MESSAGE_BLOCK_REASONS = [
  '400401_failure',
  '400402_offensive',
  '400403_promotion',
  '400404_misc',
]
